if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"accBidding","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1083|2445|3243)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}